import React from 'react';
import { motion } from 'framer-motion';
export function ProductMockup() {
  return <motion.div className="relative w-full max-w-md mx-auto" initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} data-id="element-219">
      <img src="https://cdn.magicpatterns.com/uploads/x8CNhGpzXp5BKSDJqEAPxg/393.png" alt="Megapack STRETCHING 360 — Curso Elite Completo: 12 tomos, 6 bonus en PDF y 2 ebooks élite" className="w-full h-auto drop-shadow-2xl" data-id="element-220" />
    </motion.div>;
}